import React, { useEffect } from 'react';
import ContactInfo from '../ContactInfo/ContactInfo';
import Footer from '../../Footer/Footer';
import Header from '../../Header/Header';

const ContactUs = (props) => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [props]);

	return (
		<>
			<Header />
			<div className="container d-flex flex-column">
				<div className="row align-items-center justify-content-between no-gutters min-vh-100">
					<div className="col-12 col-md-6 align-self-stretch">
						<ContactInfo heading="Contact Information" />
						<div className="row col-md-12 col-sm-12 justify-content-around">
							<p className="font-size-inherit text-gray-800">
								Do reach out to us for information on our products or for any
								queries.
							</p>
							<p className="font-size-inherit text-gray-800">
								We are happy to take feedback from our customers to improvise
								our products and services.
							</p>
						</div>

						{/* Business Enquiries Section */}
						<div className="mt-5 mb-4">
							<h5 className="text-gray-900 mb-3">
								<i
									className="fa fa-briefcase mr-2"
									style={{ color: '#13397F' }}
								></i>
								Business Enquiries
							</h5>
							<div className="row ml-0 mt-4 align-items-center">
								<div className="col-md-2 col-sm-2 d-flex justify-content-center">
									<i
										className="fa fa-envelope fa-2x"
										style={{ color: '#13397F' }}
									></i>
								</div>
								<div className="col-md-10 col-sm-10">
									<div className="mb-2">
										<strong>General Enquiries</strong>
									</div>
									<p className="mb-2 font-size-sm text-gray-800">
										<a
											href="mailto:info@cookiejar.co.in"
											className="text-decoration-none"
										>
											info@cookiejar.co.in
										</a>
									</p>
									<button
										className="btn btn-sm btn-outline-primary"
										onClick={() =>
											window.open('mailto:info@cookiejar.co.in', '_blank')
										}
									>
										<i className="fa fa-envelope mr-1"></i>
										Send Email
									</button>
								</div>
							</div>
						</div>

						{/* HR & Background Verification Section */}
						<div className="mt-5 mb-4">
							<h5 className="text-gray-900 mb-3">
								<i
									className="fa fa-users mr-2"
									style={{ color: '#74B570' }}
								></i>
								HR & Background Verification
							</h5>
							<p className="font-size-sm text-gray-700 mb-4">
								For employment verification, reference checks, background
								verification services, and HR-related enquiries. We provide
								comprehensive verification services for corporate clients and
								individuals.
							</p>

							<div className="row ml-0 mt-4 align-items-center">
								<div className="col-md-2 col-sm-2 d-flex justify-content-center">
									<i
										className="fa fa-envelope fa-2x"
										style={{ color: '#13397F' }}
									></i>
								</div>
								<div className="col-md-10 col-sm-10">
									<div className="mb-2">
										<strong>Background Verification Services</strong>
									</div>
									<p className="mb-2 font-size-sm text-gray-800">
										<a
											href="mailto:hr@cookiejar.co.in"
											className="text-decoration-none"
										>
											hr@cookiejar.co.in
										</a>
									</p>
									<p className="mb-2 font-size-xs text-gray-600">
										Employment verification, reference checks, credential
										verification
									</p>
									<button
										className="btn btn-sm btn-outline-success"
										onClick={() =>
											window.open('mailto:hr@cookiejar.co.in', '_blank')
										}
									>
										<i className="fa fa-envelope mr-1"></i>
										Send Email
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</>
	);
};

export default ContactUs;
